export default function reducer(state={
    list:[],
    activeDeal:{
        title:"",
        id:0,
        description:"",
        discount:null,
        image_name:null,
        updated:false,
    }
},action){

    switch(action.type){
        case "STORE_DEALS":{
            return{...state,list:action.deals}
        }
        case "STORE_ACTIVE_DEAL":{
            return{...state,activeDeal:{
                ...state.activeDeal,
                id:action.deal.id,
                title:action.deal.title,
                description:action.deal.description,
                discount:action.deal.discount,
                image_name:action.deal.image_name,
                updated:true
            }}
        }
        case "LOCK_ACTIVE_DEAL":{
            return{...state,activeDeal:{
                ...state.activeDeal,                
                updated:false
            }}
        }         
    }

    return state;
}